<template>
  <el-dialog :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <template slot="title">
      <span class="el-dialog__title">{{title}}
        <span class="state have" v-if="list.RefundTaxState==1">({{$t('base.processing')}})</span>
        <span class="state pass" v-if="list.RefundTaxState==2">({{$t('base.taxrefunded')}})</span>
        <span class="state reject" v-if="list.RefundTaxState==3">({{$t('base.rejected')}})</span>
      </span>
    </template>
    <div id="dialogBoxWare" class="dialogData">
      <ul class="orderStateDetail">
        <li><span class="text_gray">{{$t('base.ordertype')}}:</span>{{list.BusinessType==2?$t('base.crossBorder'):$t('base.domestic')}}</li>
        <li><span class="text_gray">{{$t('base.applicationtime')}}:</span>{{setTime(list.CreateDate)}}</li>
        <li><span class="text_gray">{{$t('base.orderquantity')}}:</span>{{list.OrderListCount}}</li>
        <li class="flex">
          <div><span class="text_gray">{{$t('base.requestedRefundAmount')}}:</span>{{list.RealDrawBackAmountUnit}} {{list.ForecastDrawBackAmount.toFixed(2)}}</div>
          <div v-if="list.RefundTaxState==2"><span class="text_gray">{{$t('base.actualRefundAmount')}}:</span>{{list.RealDrawBackAmountUnit}} {{list.RealDrawBackAmount.toFixed(2)}}</div>
        </li>
        <li class="flex">
          <div><span class="text_gray">Real Name:</span>{{list.RealName}}</div>
          <div v-if="list.CompanyName"><span class="text_gray">Company Name:</span>{{list.CompanyName}}</div>
        </li>
        <li v-if="list.Note"><span class="text_gray">Note:</span>{{list.Note}}</li>
        <li><span class="text_gray">{{$t('base.taxState')}}:</span>
          <span class="state have" v-if="list.RefundTaxState==1">{{$t('base.processing')}}</span>
          <span class="state pass" v-if="list.RefundTaxState==2">{{$t('base.taxrefunded')}}</span>
          <span class="state reject" v-if="list.RefundTaxState==3">{{$t('base.rejected')}}</span></li>
        <li v-if="list.RefundTaxState==3"><span class="text_gray">{{$t('base.reason')}}:</span>{{list.Remarks}}</li>
        <li><span class="text_gray">{{$t('base.photoOrPDFByUser')}}</span>
          <div v-for="(item,index) in list.Proves" :key="index">
            <el-image v-if="item.Type==1" class="like_img" :src="item.Url+'?imageView2/2/w/200'" fit="contain" lazy :preview-src-list="[item.Url]"></el-image>
            <a :href="item.Url" target="_blank" v-if="item.type==2">
              <el-image :src="fileUrl" class="like_img" fit='contain' />
            </a>
          </div>
        </li>
      </ul>
      <div class="orderListBox">
        <div class="orderList orderListTop">
          <div>{{$t('base.orderNumber')}}</div>
          <div>{{$t('base.tax')}}</div>
          <div>{{$t('base.orderTotal')}}</div>
          <div class="createTime">{{$t('base.createTime')}}</div>
          <div class="operate">{{$t('base.operate')}}</div>
        </div>
        <el-scrollbar>
          <ul class="orderScrollbar">
            <li class="orderList" v-for="(item,index) in list.OrderList" :key="index">
              <div>{{item.Code}}</div>
              <div>{{item.RealLowestPriceUnit}} {{item.TaxPriceUsd.toFixed(2)}}</div>
              <div>{{item.RealLowestPriceUnit}} {{item.RealTotalPrice.toFixed(2)}}</div>
              <div class="createTime">{{setTime(item.CreateDate)}}</div>
              <div class="operate"><span class="view" @click="goto(item,'taxorderlist')">{{$t('base.viewDetails')}}</span></div>
            </li>
          </ul>
        </el-scrollbar>
        <tax-order-list title="Order Details" dialogClass="taxBox" :list="taxOrderDetail" :domVisible='dislogType.taxorderlist' @closeDialog="closeDialog" v-if='dislogType.taxorderlist' />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getTime } from "@/api/public";
import NOTN from "@/components/notnull.vue";
import TaxOrderList from "@/components/dialog/taxorderlist"; // 
export default {
  name: 'taxDetails',
  components: { TaxOrderList, NOTN },
  data() {
    return {
      fileUrl: '../../../static/images/icon/icon_file.svg',
      taxOrderDetail: {},
      dislogType: this.$enumInfo.dislogType
    }
  },
  props: {
    dialogClass: '',
    title: '',
    domVisible: Boolean,
    list: {},
    userInfo: {}
  },
  watch: {},
  filters: {},
  created() {},
  methods: {

    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    handleClose() {
      this.$emit('closeDialog', 'taxDetails', false)
    },
    goto(obj, val) {
      this.taxOrderDetail = obj
      this.closeDialog(val, true)
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#dialogBoxWare {
  min-height: 400px;
  max-height: 80vh;
}

.orderList {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.orderListTop {
  background-color: #f7f7f7;
}

.orderList>div {
  width: 20%;
  padding: 16px 12px;
  color: #333;
  box-sizing: border-box;
}

.orderList>div.createTime {
  width: 25%;
}

.orderList>div.operate {
  width: 15%;
}

.view {
  cursor: pointer;
}

.view:hover {
  color: #5F6DAE;
  text-decoration: underline;
}

.like_img {
  width: 104px;
  height: 104px;
  display: block;
  margin-top: 16px;
}

.orderStateDetail li {
  margin-bottom: 16px;
}

.orderStateDetail li span {
  margin-right: 8px;
}
.flex>div{
  width: 50%;
}

.orderScrollbar {
  height: 178px;
}

.state.pass {
  color: #58A800;
}

.state.reject {
  color: #E02020;
}

.state.have {
  color: #F0AD4E;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/taxDetails.vue